import { MSG_ALERTA, MSG_SUCESSO } from '@/utils/mensagens.helper'

export default {
  methods: {
    // { tipo: Tipo do alerta, mensagem: Array de erros }
    tratarRespostaMsg(objRetorno) {
      if (this.hasOwnProperty('isLoading')) {
        this.isLoading = false
      }

      const { tipo, mensagens } = objRetorno
      if (mensagens) {
        switch (tipo) {
          case MSG_SUCESSO: {
            mensagens.forEach(mensagem => {
              this.$awn.success(mensagem)
            })
            break
          }

          case MSG_ALERTA: {
            mensagens.forEach(mensagem => {
              this.$awn.warning(mensagem)
            })
            break
          }

          default: {
            mensagens.forEach(mensagem => {
              this.$awn.alert(mensagem)
            })
          }
        }
      }
    },
  },
}
